module.exports = __webpack_public_path__ + "static/media/intensub2menu.78e714e4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/img/intensub2menu.PNG
// module id = 95
// module chunks = 0